import { Fragment } from 'react';

import Button, { ButtonKind } from 'bloko/blocks/button';
import { FormSpacer } from 'bloko/blocks/form';
import InputText from 'bloko/blocks/inputText';
import Select, { Option } from 'bloko/blocks/select';

import useTrl from 'hooks/translation/useTrls';

import AdminFilterWrapper from 'components/Filter';

import fetchTranslations from 'components/Admin/Translations/Filter/fetchTranslations';

import { setFilterType, setFilterValue, TranslationsFilterType } from 'store/models/translations';
import { useDispatch, useSelector } from 'store/utils';

const Filter = () => {
    const { filterType, filterValue } = useSelector((state) => state.translations);
    const dispatch = useDispatch();
    const trl = useTrl();

    return (
        <AdminFilterWrapper
            settings={
                <Fragment>
                    <Select
                        value={filterType}
                        onChange={(event) => dispatch([setFilterType(event.target.value), setFilterValue('')])}
                    >
                        {Object.values(TranslationsFilterType).map((value) => (
                            <Option key={value} value={value}>
                                {trl(`admin.Translations.Filter.FilterType.${value}`)}
                            </Option>
                        ))}
                    </Select>
                    <FormSpacer>
                        <InputText
                            value={filterValue}
                            onChange={(value) => dispatch(setFilterValue(value))}
                            size="40"
                            placeholder={trl(`admin.Translations.Filter.placeholder.${filterType}`)}
                        />
                    </FormSpacer>
                </Fragment>
            }
            actions={
                <Button kind={ButtonKind.Primary} onClick={() => dispatch(fetchTranslations())}>
                    {trl('admin.Translations.Filter.find')}
                </Button>
            }
        />
    );
};

export default Filter;
